import { MapMarker } from '../models';

export const fitBounds = (map: google.maps.Map, locations: MapMarker[], limitMarkers: number) => {
    const bounds = new google.maps.LatLngBounds();

    locations.slice(0, limitMarkers).forEach((m) => {
        const makerBounds = new google.maps.LatLng(m.lat, m.lng);
        bounds.extend(makerBounds);
    });

    map.fitBounds(bounds, 30);
};
